module.exports = __webpack_public_path__ + "static/img/5646_phase_function_Paper_Points.8aeae49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5646_phase_function_Paper_Points.png
// module id = 8oGb
// module chunks = 0